import React from 'react';
import {observer} from "mobx-react-lite";

const Loading = () => {
  return (
    <div className="loading active">
      <div className="spinner">
        <div className="cube1" />
        <div className="cube2" />
      </div>
    </div>
  );
};

export default observer(Loading);